import { render, staticRenderFns } from "./MyOrdersCard.vue?vue&type=template&id=7cc8f081"
import script from "./MyOrdersCard.vue?vue&type=script&lang=js"
export * from "./MyOrdersCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports